import { auth } from './firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';

// Test Firebase connection
const testFirebaseConnection = async () => {
  console.log('Testing Firebase connection...');
  console.log('Auth config:', auth.config);
  
  try {
    // Try to create a test user (this will fail if auth is not configured)
    const result = await createUserWithEmailAndPassword(auth, 'test@example.com', 'test123456');
    console.log('Firebase auth working:', result);
  } catch (error) {
    console.error('Firebase auth error:', error.code, error.message);
    
    // Check for specific errors
    if (error.code === 'auth/configuration-not-found') {
      console.error('❌ Email/Password authentication is NOT enabled in Firebase');
      console.log('🔧 Please enable it in Firebase Console > Authentication > Sign-in method');
    } else if (error.code === 'auth/email-already-in-use') {
      console.log('✅ Firebase auth is working (email already exists is expected)');
    } else if (error.code === 'auth/network-request-failed') {
      console.error('❌ Network error - check internet connection');
    } else {
      console.error('❌ Other Firebase error:', error);
    }
  }
};

export default testFirebaseConnection;
